// เชิญประชุม แก้ไขข้อบังคับบริษัท

import React from "react";
import PrintField from "../../shared/PrintField";
import "./MeetingInvitationforAmendmentofCompanyRegulations.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

const CompanyRegulations = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      {/* ref ต้องเกาะที่ A4 */}
      <div className="inv-paper" ref={ref}>
        <div className="inv-header-right">
          <div className="inv-bold">
            บริษัท{" "}
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "200px" }}
              spellCheck={false}
            />
          </div>

          <div className="inv-header-date inv-bold">
            วันที่{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "50px" }}
              spellCheck={false}
            />{" "}
            เดือน{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
              spellCheck={false}
            />{" "}
            ปี{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
              spellCheck={false}
            />
          </div>
        </div>

        <div className="inv-body">
          {/* เรื่อง */}
          <div className="inv-row">
            <span className="inv-bold">
              เรื่อง&nbsp;&nbsp;ขอเชิญประชุมวิสามัญผู้ถือหุ้นประจำปี
            </span>
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "60px" }}
              spellCheck={false}
            />
          </div>

          {/* เรียน */}
          <div className="inv-row inv-row-learn inv-bold">
            เรียน&nbsp;&nbsp;ท่านผู้ถือหุ้นบริษัท{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "120px" }}
              spellCheck={false}
            />
          </div>

          {/* เนื้อหา */}
          <p className="inv-paragraph">
            ด้วยที่ประชุมคณะกรรมการบริษัท{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "140px" }}
              spellCheck={false}
            />{" "}
            มีมติให้เรียกประชุมวิสามัญผู้ถือหุ้นประจำปี
            
            ครั้งที่{" "}
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />
            <span className="inv-sep">/</span>
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />{" "}
            ในวันที่{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "40px" }}
              spellCheck={false}
            />{" "}
            เดือน{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "70px" }}
              spellCheck={false}
            />{" "}
            ปี{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "60px" }}
              spellCheck={false}
            />{" "}
            เวลา{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "50px" }}
              spellCheck={false}
            />{" "}
            น.
            
            ณ สำนักงานของบริษัท{" "}
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "180px" }}
              spellCheck={false}
            />{" "}
            โดยมีระเบียบวาระการประชุมดังนี้ คือ
          </p>

          {/* วาระประชุม (แก้ไขข้อบังคับ) */}
          <div className="inv-agenda">
            <div className="inv-agenda-item">
              วาระที่ 1 พิจารณาเรื่องการแก้ไขข้อบังคับของบริษัท
            </div>

            <div className="inv-agenda-item">
              รายละเอียดข้อเสนอแก้ไขข้อบังคับ{" "}
              <InputField
                className="inv-line inv-line-long"
                style={{ width: "280px" }}
                spellCheck={false}
              />
            </div>

            <div className="inv-agenda-item">
              วาระที่ 2 พิจารณาเรื่องอื่นๆ (ถ้ามี)
            </div>
          </div>

          {/* ปิดท้าย */}
          <p className="inv-paragraph">
            ดังนั้น จึงขอเรียนเชิญท่านผู้ถือหุ้นเข้าประชุมตามวัน เวลา และสถานที่ดังกล่าวข้างต้น
            หากท่านไม่สามารถจะไปประชุมด้วยตนเองได้ โปรดทำหนังสือมอบฉันทะ
            เพื่อมอบอำนาจให้ผู้อื่นไปประชุมแทนด้วย จะขอบคุณมาก
          </p>

          {/* ลายเซ็น */}
          <div className="inv-footer">
            <div className="inv-footer-text">ขอแสดงความนับถือ</div>

            <div className="inv-sign-block">
              <InputField className="inv-sign-line" spellCheck={false} optional />
              <div className="inv-sign-name">
                ( <InputField className="inv-sign-name-field" printFit optional={false} /> )
              </div>
              <div className="inv-sign-role">กรรมการ</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default CompanyRegulations;
